<template>
    <div class="component-group"
         :class="{
            active: !!isStatusYes
         }"
    >
        <form-group :label="`${$t(`${translationsGroup}.blood_donor_out_of_borders`)}`"
                    :errors="errors"
                    label-for="bloodDonorInCountry"
                    name="blood_donor_in_other_country"
        >
            <select-box :options="options"
                        :value="status"
                        :disabled="isLoading"
                        :default-item="defaultItem"
                        :placeholder="$t(`${placeholderGroup}.select_option`)"
                        id="bloodDonorInCountry"
                        name="blood_donor_in_other_country"
                        @update="onUpdateBloodDonorStatus"
            />
        </form-group>
        <country-select v-if="!!isStatusYes"
                        :value="statusOther"
                        :label="$t(`${translationsGroup}.blood_donor_which_country`)"
                        :placeholder="$t(`${placeholderGroup}.select_option`)"
                        :errors="errors"
                        name="blood_donor_other_country_name"
                        @update="onUpdateBloodDonorStatus"
        />
    </div>
</template>

<script>
import SelectBox from '../../../../../../Components/Forms/SelectBox/SelectBox';
import FormGroup from '../../../../../../Components/Forms/Holders/FormGroup';
import CountrySelect from '../../../../../../Components/Forms/Select/CountrySelect';

export default {
    name: 'BloodDonorOtherCountry',
    emits: [
        'update',
    ],
    components: {
        SelectBox,
        FormGroup,
        CountrySelect,
    },
    props: {
        status: {},
        statusOther: {},
        errors: {
            default: null
        },
        translationsGroup: {
            type: String,
            default: 'words'
        },
        placeholderGroup: {
            type: String,
            default: 'placeholders'
        },
        defaultItem: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isLoading: false,
            options: [
                {
                    'label': this.$t('words.yes'),
                    'value': 'yes'
                },
                {
                    'label': this.$t('words.no'),
                    'value': 'no'
                }
            ],
        };
    },
    computed: {
        isStatusYes() {
            return this.status === 'yes';
        },
    },
    methods: {
        onUpdateBloodDonorStatus(name, value) {
            this.$emit('update', name, value);
        },
    },
}
</script>